(() => {
  const getProductForm = () =>
    document.querySelector('[data-section-type="product"] [data-product-form]');

  const setBackInStockState = soldOut => {
    const productForm = getProductForm();
    if (!productForm) return;

    const primaryAction = productForm.querySelector('[data-product-primary-action]');
    const addButton = productForm.querySelector('[data-add-to-cart]');
    const notifyTrigger = productForm.querySelector('[data-product-bis-trigger]');
    if (!primaryAction || !addButton || !notifyTrigger) return;

    primaryAction.dataset.bisState = soldOut ? 'sold-out' : 'available';
    addButton.toggleAttribute('data-bis-pending', soldOut);
    addButton.removeAttribute('hidden');
    notifyTrigger.hidden = true;

    if (soldOut) {
      const addButtonText = addButton.querySelector('[data-add-to-cart-text]');
      if (addButtonText) addButtonText.textContent = notifyTrigger.textContent.trim();
    }
  };

  document.addEventListener('product:variant-change', event => {
    const variant = event.detail?.variant;
    const soldOut = Boolean(variant && !variant.available);
    setBackInStockState(soldOut);
    requestAnimationFrame(() => setBackInStockState(soldOut));
  });

  const productForm = getProductForm();
  if (!productForm) return;

  const addButton = productForm.querySelector('[data-add-to-cart]');
  setBackInStockState(Boolean(addButton?.hasAttribute('data-bis-pending')));
})();
